export default {
    accountSettingsTitle: "Account Settings",
    accountSettingsDescription: "Manage your account preferences and security",
    accountSettingsTabTitle1: "Profile",
    accountSettingsTabTitle2: "Theme",
    accountSettingsTabTitle3: "Security",
    accountSettingsTabTitle4: "Subscription",
    accountSettingsSaveChangesActionLabel: "Save Changes",
    accountInfoTitle: "Account Info",
    membershipInfoLabel: "Member since",
    totalTestsLabel: "Total tests",
    totalStudyTimeLabel: "Study hours",
    dangerZoneLabel: "Danger Zone",
    logoutActionLabel: "Logout",
    deleteAccountActionLabel: "Delete Account",
    deleteAccountDialogTitle: "Delete your account?",
    deleteAccountDialogDescription: "This permanently deletes your LinguaScore account. It can't be undone. You will lose:",
    deleteAccountDialogItemProfile: "Your profile and sign-in",
    deleteAccountDialogItemResults: "Your test history, answers and results",
    deleteAccountDialogItemRecordings: "Your speaking recordings",
    deleteAccountDialogItemSubscription: "Any remaining subscription time",
    deleteAccountDialogPaymentNotice: "Payment records are kept for 7 years, as required by financial regulations.",
    deleteAccountPasswordPrompt: "Enter your password to confirm",
    deleteAccountEmailPrompt: "Type {{email}} to confirm",
    deleteAccountConfirmActionLabel: "Delete my account",
    themeTitle: "UI Theme",
    lightThemeLabel: "Light Theme",
    darkThemeLabel: "Dark Theme",
    gorillaThemeLabel: "Gorilla Theme",
    preferredLanguageLabel: "Language",
    preferredLanguageENOptionLabel: "English",
    preferredLanguageENOptionDescription: "Platform and feedback content in english while keeping the intended exam language during practice and mock tests",
    preferredLanguageFROptionLabel: "French",
    preferredLanguageFROptionDescription: "Platform and feedback content in french while keeping the intended exam language during practice and mock tests",
}
